export default __webpack_public_path__ + "static/media/ArialBold.12d05860.ttf";